import GetApi from '../api/get'

export function error(element, res = "", message = "") {
  return {
    type: 'ERROR',
    element: element || "main",
    message: (res && res.body && res.body.error) || message
  }
}

export function setState(params) {
  return {
    type: 'SET_STATE_LISTING',
    params: params
  }
}

export function get() {
  return async (dispatch, getState) => {
    const roomGroupId = getState().listing.room_group_id
    const getApi = new GetApi()
    await getApi.execute(routeUrlHelper.listingPath(roomGroupId)).then((res) => {
      dispatch(setState(res.body))
    }).catch((res) => {
    })
  }
}
